/**
 * DrewCore navbar + reszponzív menü.
 *
 * Felelősség:
 *   - navbar scroll-class toggle ('.scrolled')
 *   - MOBIL (<992px): overlay open/close, submenu accordion, scroll lock, focus trap
 *   - ASZTAL (≥992px): horizontal dropdown -- chevron click toggle, outside click/ESC close
 *   - Resize handler: mobil→desktop váltáskor bezárja a nyitott overlay-t
 *
 * HTML hookok (lásd template-parts/components/navbar.php):
 *   - .navbar
 *   - .navbar__desktop-nav                -- asztali horizontal menü konténer
 *   - [data-dc-menu-toggle]               -- hamburger / X (overlay nyit/zár)
 *   - [data-dc-menu-overlay]              -- a fullscreen overlay konténer
 *   - [data-dc-submenu]                   -- almenüs <li> (mindkét kontextusban)
 *   - [data-dc-submenu-toggle]            -- almenü nyitó <button>
 */

(function () {
  'use strict';

  /* ============================================================
     1) NAVBAR SCROLL CLASS
     ============================================================ */
  var navbar = document.querySelector('.navbar');
  if (navbar) {
    var SCROLL_THRESHOLD = 50;
    var scrollTicking = false;

    var onScroll = function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        if (window.scrollY > SCROLL_THRESHOLD) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
        scrollTicking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     2) FULLSCREEN OVERLAY MENU
     ============================================================ */
  var overlay = document.querySelector('[data-dc-menu-overlay]');
  if (!overlay) return;

  var toggles = document.querySelectorAll('[data-dc-menu-toggle]');
  if (!toggles.length) return;

  var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var openOverlay = function () {
    overlay.hidden = false;
    // Force reflow before adding is-open, so the CSS transition fires
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    document.body.classList.add('dc-menu-locked');

    toggles.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    // Fókuszt az overlay első fókuszálható elemére
    var first = overlay.querySelector(FOCUSABLE_SELECTOR);
    if (first) {
      // A nyitó animáció alatt is működjön → kis késleltetés
      window.setTimeout(function () { first.focus(); }, 50);
    }
  };

  var closeOverlay = function () {
    overlay.classList.remove('is-open');
    document.body.classList.remove('dc-menu-locked');

    toggles.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    // Almenüket is bezárjuk
    closeAllSubmenus();

    // A `hidden` csak az animáció után kerül vissza
    var onEnd = function (e) {
      if (e.target !== overlay) return;
      // Ha közben újra megnyitották, ne tegyük vissza a hidden-t
      if (overlay.classList.contains('is-open')) return;
      overlay.hidden = true;
    };
    overlay.addEventListener('transitionend', onEnd, { once: true });

    // Visszafókusz a navbar nyitó gombra (ha van)
    var navbarToggle = document.querySelector('.navbar [data-dc-menu-toggle]');
    if (navbarToggle) navbarToggle.focus();
  };

  var isOverlayOpen = function () {
    return overlay.classList.contains('is-open');
  };

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOverlayOpen()) {
        closeOverlay();
      } else {
        openOverlay();
      }
    });
  });

  /* ESC kulcs → bezár */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOverlayOpen()) {
      e.preventDefault();
      closeOverlay();
    }
  });

  /* Focus trap (Tab + Shift+Tab) az overlay-en belül */
  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !isOverlayOpen()) return;

    var focusable = Array.prototype.slice.call(overlay.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;

    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ============================================================
     3) SUBMENU ACCORDION (mobil overlay -- Szolgáltatások stílus)
     - Csak az overlay-en belüli toggle-eket fűzzük rá.
     - Az asztali dropdown toggle-eket a 4) blokk kezeli.
     ============================================================ */
  var submenuToggles = overlay.querySelectorAll('[data-dc-submenu-toggle]');

  var closeAllSubmenus = function () {
    overlay.classList.remove('has-submenu-open');
    submenuToggles.forEach(function (toggle) {
      var li = toggle.closest('[data-dc-submenu]');
      if (!li) return;
      li.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      var submenu = li.querySelector('.dc-menu__submenu');
      if (submenu) {
        submenu.hidden = true;
        submenu.style.maxHeight = '';
      }
    });
  };

  submenuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var li = toggle.closest('[data-dc-submenu]');
      if (!li) return;
      var submenu = li.querySelector('.dc-menu__submenu');
      if (!submenu) return;

      var isOpen = li.classList.contains('is-open');

      // Mindig zárjunk be minden almenüt (csak egy lehet nyitva)
      submenuToggles.forEach(function (other) {
        if (other === toggle) return;
        var otherLi = other.closest('[data-dc-submenu]');
        if (!otherLi) return;
        otherLi.classList.remove('is-open');
        other.setAttribute('aria-expanded', 'false');
        var otherMenu = otherLi.querySelector('.dc-menu__submenu');
        if (otherMenu) {
          otherMenu.hidden = true;
          otherMenu.style.maxHeight = '';
        }
      });

      if (isOpen) {
        // Zárás
        li.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        // Először a jelenlegi scrollHeight-ra kell beállítani, hogy a 0-ra animáció működjön
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        void submenu.offsetWidth;
        submenu.style.maxHeight = '0px';
        overlay.classList.remove('has-submenu-open');

        var onClose = function (ev) {
          if (ev.propertyName !== 'max-height') return;
          if (li.classList.contains('is-open')) return; // Közben újra megnyílt
          submenu.hidden = true;
          submenu.style.maxHeight = '';
        };
        submenu.addEventListener('transitionend', onClose, { once: true });
      } else {
        // Nyitás
        submenu.hidden = false;
        // Reflow után állítjuk be a max-height-t, hogy az animáció fusson
        void submenu.offsetWidth;
        li.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        overlay.classList.add('has-submenu-open');
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
      }
    });
  });

  /* ============================================================
     4) DESKTOP DROPDOWN SUBMENU (≥992px)
     - Hover: CSS-ben kezeljük (opacity/visibility)
     - Click a chevron-en: toggle is-open class (perzisztens nyitás)
     - Outside click / ESC: bezárja az összes asztali almenüt
     ============================================================ */
  var desktopNav = document.querySelector('.navbar__desktop-nav');

  var closeAllDesktopSubmenus = function (exceptLi) {
    if (!desktopNav) return;
    var openItems = desktopNav.querySelectorAll('[data-dc-submenu].is-open');
    openItems.forEach(function (li) {
      if (li === exceptLi) return;
      li.classList.remove('is-open');
      var btn = li.querySelector('[data-dc-submenu-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };

  if (desktopNav) {
    /* Init: az asztali submenu-króól levesszük a `hidden` attribute-ot,
       mert asztalon a CSS opacity/visibility-vel rejti/mutatja. A `hidden`
       attribute UA stylesheet `display: none`-ja ellentmondana ennek. */
    var desktopSubmenus = desktopNav.querySelectorAll('.dc-menu__submenu');
    desktopSubmenus.forEach(function (sm) {
      sm.removeAttribute('hidden');
    });

    var desktopSubmenuToggles = desktopNav.querySelectorAll('[data-dc-submenu-toggle]');

    desktopSubmenuToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var li = toggle.closest('[data-dc-submenu]');
        if (!li) return;

        var isOpen = li.classList.contains('is-open');

        // Mindig zárjunk be minden más asztali almenüt (egyszerre csak egy nyitva)
        closeAllDesktopSubmenus(isOpen ? null : li);

        if (isOpen) {
          li.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          li.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Kívülre kattintás → bezárja az asztali almenüket
    document.addEventListener('click', function (e) {
      if (!desktopNav.contains(e.target)) {
        closeAllDesktopSubmenus();
      }
    });

    // ESC → bezárja az asztali almenüket
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllDesktopSubmenus();
      }
    });
  }

  /* ============================================================
     5) RESIZE HANDLER -- mobil ↔ desktop bp váltás
     - Ha a felhasználó mobilról asztalra vált, és közben nyitva volt
       az overlay vagy egy mobil almenü, biztonságosan bezárjuk.
     - Ha asztalról mobilra vált, az asztali dropdown-okat zárjuk.
     ============================================================ */
  var desktopMql = window.matchMedia('(min-width: 992px)');
  var onMqlChange = function (e) {
    if (e.matches) {
      // → desktop
      if (isOverlayOpen()) {
        closeOverlay();
      }
    } else {
      // → mobil
      closeAllDesktopSubmenus();
    }
  };
  if (typeof desktopMql.addEventListener === 'function') {
    desktopMql.addEventListener('change', onMqlChange);
  } else if (typeof desktopMql.addListener === 'function') {
    desktopMql.addListener(onMqlChange); // Safari régebbi fallback
  }

})();
